import { defineMessages } from 'react-intl'

export default defineMessages({
  recipes: {
    id: 'homepage_teaser_1000_healthy_recipes_header',
    defaultMessage: 'Hundreds of Healthy Recipes',
  },
  twwl: {
    id: 'Kickstarter.titleShort',
    defaultMessage: '3 Week Weight Loss Program',
  },
  sync: {
    id: 'homepage_teaser_sync_with_health_apps_header',
    defaultMessage: 'Easy Sync with Health Apps',
  },
  plans: {
    id: 'homepage_teaser_keto_clean_eating_other_diet_plans_header',
    defaultMessage: 'Keto, Clean Eating & Other Diet Plans',
  },
  tracking: {
    id: 'homepage_teaser_macro_net_carb_tracking_header',
    defaultMessage: 'Macro & Net Carb Tracking\n',
  },
  'upgrade.checklist_lifescore': {
    id: 'upgrade.checklist_lifescore',
    defaultMessage:
      'Food ratings, nutrition tips & health advice with Life Score™',
  },
})
